<ng-template #signAuthDialogTemplate>
    <form class="se-auth-dialog-container se-flex se-expand" (ngSubmit)="closeModal(false)">
        <div class="se-flex se-vertical se-expand">
            <div class="se-dialog-header mat-elevation-z6" [class.se-dialog-header-error]="isOnError">
                <h3 mat-dialog-title translate><span translate>Sign</span> - <span translate>Authenticate</span></h3>
            </div>

            <div class="se-sign-dialog-content" mat-dialog-content [class.se-sign-dialog-waiting]="isWaiting | async">
                <div class="mat-input-container">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "Username" | translate }}</mat-label>
                        <input name="sign_username"
                               matInput
                               [placeholder]="'Signer' | translate"
                               [(ngModel)]="data.info.signerName"
                               tabindex="-1"
                               autocomplete="off"
                               readonly />
                    </mat-form-field>

                    <!-- Pin Text Box -->
                    <mat-form-field appearance="outline" *ngIf="isPinRequired()">
                        <mat-label>{{ pinLabel | translate }}</mat-label>
                        <input #pin
                               name="sign_pin"
                               [type]="showPin ? 'text' : 'password'"
                               matInput
                               [placeholder]="pinLabel | translate"
                               [(ngModel)]="data.info.pin"
                               autocomplete="new-password"
                               required />
                        <button type="button"
                                matSuffix
                                mat-icon-button
                                aria-label="Show"
                                (click)="showPin = !showPin"
                                tabindex="-1">
                            <mat-icon>{{ showPin ? "visibility_off" : "visibility" }}</mat-icon>
                        </button>
                        <button *ngIf="!!data.info.pin"
                                type="button"
                                matSuffix
                                mat-icon-button
                                aria-label="Clear"
                                (click)="data.info.pin = ''"
                                tabindex="-1">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>

                    <!-- OTP text box (e OTP Buttons confrimo e siss)-->
                    <div style="display:flex;flex-direction:row">
                        <mat-form-field appearance="outline" *ngIf="isOtpRequired()" style="flex:1">
                            <mat-label>{{ "OTP" | translate }}</mat-label>
                            <input #otp
                                   name="otp"
                                   type="password"
                                   matInput
                                   [placeholder]="'OTP' | translate"
                                   [(ngModel)]="oneTimePwd"
                                   autocomplete="new-password"
                                   required />
                            <button *ngIf="!!oneTimePwd"
                                    type="button"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Clear"
                                    (click)="oneTimePwd = ''"
                                    tabindex="-1">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>

                        <!-- OTP button Confirmo -->
                        <button mat-icon-button *ngIf="canRequestConfirmoOtp()"
                                style="align-self:center"
                                type="button"
                                (click)="onRequestConfirmoOtp($event)"
                                [matTooltip]=" 'RequestOtp' | translate"
                                [disabled]="isRequestOtpConfirmoDisabled">
                            <mat-icon>sms</mat-icon>
                        </button>
                    </div>

                    <!-- OTP button SISS -->
                    <button *ngIf="canRequestSissOtpSms()"
                            type="button"
                            mat-raised-button
                            color="primary"
                            translate
                            [disabled]="isRequestOtpSmsDisabled$ | async"
                            (click)="onRequestSissOtpSms($event)">
                        <div class="otp-sms-button-contents">
                            <span translate>RequestOtpSms</span>
                            <mat-spinner *ngIf="(otpSmsStatus$ | async) === 'loading'; else smsIcon"
                                         diameter="20"></mat-spinner>
                            <ng-template #smsIcon>
                                <mat-icon>sms</mat-icon>
                            </ng-template>
                        </div>
                    </button>

                    <!-- Certificati e otp button Scrybasign -->
                    <div style="display:flex;flex-direction:row">
                        <img style="align-self: center; width: 48px; height: 48px"
                             *ngIf="canRequestScrybaOtp('YUBICO8')"
                             src="assets/images/yubico8.png"
                             tooltip="Token Yubico8" />
                        <img style="align-self: center; width: 48px; height: 48px"
                             *ngIf="canRequestScrybaOtp('C100')"
                             src="assets/images/C100.png"
                             tooltip="Token C100" />
                        <img style="align-self:center;width:48px;height:48px"
                             *ngIf="canRequestScrybaOtp('APP')"
                             src="assets/images/ScrybaApp.png"
                             tooltip="Application" />

                        <mat-form-field appearance="outline" *ngIf="isCertificateRequired()" style="flex:1;margin-bottom:0">
                            <mat-label>{{ "Certificate" | translate }}</mat-label>
                            <mat-select #combocert
                                        panelClass="se-mat-select-panel-class"
                                        [disableOptionCentering]="true"
                                        name="combo-certificate"
                                        [placeholder]=""
                                        [ngModel]="getSelectedCertificate()"
                                        (ngModelChange)="setSelectedCertificate($event)">
                                @for (cert of getCertificates(); track cert) {
                                <mat-option [value]="cert.code">{{cert.description}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <!-- OTP Button Scryba -->
                        <button mat-icon-button *ngIf="canRequestScrybaOtp('SMS')" style="align-self:center"
                                type="button"
                                (click)="onRequestScrybaOtp($event, 'SMS')"
                                [matTooltip]=" 'RequestOtpSms' | translate"
                                [disabled]="isRequestOtpScrybaDisabled">
                            <mat-icon>sms</mat-icon>
                        </button>

                        <button mat-icon-button *ngIf='canRequestScrybaOtp("ARUBACALL")' style="align-self:center"
                                type="button"
                                (click)="onRequestScrybaOtp($event, 'ARUBACALL')"
                                [matTooltip]=" 'RequestOtpArubaCall' | translate"
                                [disabled]="isRequestOtpScrybaDisabled">
                            <mat-icon>call</mat-icon>
                        </button>
                    </div>

                    <!-- DeviceId Confirmo -->
                    <mat-form-field appearance="outline" style="flex:1;margin-bottom:0" *ngIf="isDeviceIdSelectRequired()">
                        <mat-label>{{ "OTPDevices" | translate }}</mat-label>
                        <mat-select #combocert
                                    panelClass="se-mat-select-panel-class"
                                    [disableOptionCentering]="true"
                                    name="combo-deviceid"
                                    [placeholder]=""
                                    [(ngModel)]="data.confirmo.deviceId">
                            @for (device of data.confirmo.devices; track device) {
                            <mat-option [value]="device.deviceId">{{device.description}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="isTimeoutRequired()">
                        <mat-label>{{ "Timeout" | translate }}</mat-label>
                        <mat-select #signtimeout
                                    panelClass="se-mat-select-panel-class"
                                    [disableOptionCentering]="true"
                                    name="combo-timeout"
                                    [placeholder]="timeoutMessage"
                                    [(ngModel)]="timeout">
                            <ng-container>
                                <mat-option [value]="10">10 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="15">15 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="20">20 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="25">25 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="30">30 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="45">45 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="60">60 <span translate>Minutes</span></mat-option>
                                <mat-option [value]="0"><span translate>AlwaysPwd</span></mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <mat-slide-toggle *ngIf="canSessionStayOpen()"
                                      class="sign-slide-toggle"
                                      labelPosition="after"
                                      [checked]="leaveSessionOpen"
                                      (change)="leaveSessionOpen = !leaveSessionOpen"
                                      [matTooltip]="sessionHelpMsg"
                                      matTooltipPosition="right"
                                      matTooltipShowDelay="1000">
                        <span>{{ activeMessage }}</span>
                    </mat-slide-toggle>
                </div>

                <p class="se-sign-dialog-error-message">
                    &nbsp; {{ (errorMessage$ | async) }}
                </p>
            </div>
            <div class="se-sign-dialog-action-container" mat-dialog-actions>
                <button mat-button
                        color="primary"
                        class="se-dialog-action-button"
                        type="button"
                        (click)="closeModal(true)"
                        translate>
                    <span translate>Cancel</span>
                </button>

                <button mat-button
                        class="se-dialog-action-button"
                        type="button"
                        color="primary"
                        [disabled]="!enableSignButton()"
                        (click)="closeModal(false)">
                    <span translate>Confirm</span>
                </button>

                <button type="submit" [disabled]="!enableSignButton()" style="display: none">hidden submit</button>
            </div>
        </div>
    </form>

    <div class="estensa-spinner" style="background-color: transparent !important" *ngIf="isWaiting | async">
        <mat-spinner diameter="64" color="accent"></mat-spinner>
    </div>
</ng-template>
